import styles from "./AppStaticDropdown.module.scss";
import React, {Fragment, useEffect, useRef, useState} from "react";
import Form from "react-bootstrap/Form";
import clsx from "clsx";

export const AppStaticDropdown = ({
                                    value,
                                    choices,
                                    choiceGroup,
                                    onChange,
                                    isInvalid,
                                    choiceValue = choice => choice.value,
                                    choiceLabel = choice => choice.label,
                                    choiceDisplay = DefaultChoiceDisplay,
                                    id = null,
                                    disabled = false
                                  }) => {
  const valueChoice = choices.find(c => choiceValue(c) === value);

  const [choicesDisplayed, setChoicesDisplayed] = useState(false);
  const [activeChoice, setActiveChoice] = useState(valueChoice);

  const dropdownRef = useRef();
  const choicesRef = useRef();

  useEffect(() => {
    const onMousedown = e => {
      if (!dropdownRef.current.contains(e.target)) {
        setChoicesDisplayed(p => false);
      }
    };

    document.addEventListener("mousedown", onMousedown);

    return () => {
      document.removeEventListener("mousedown", onMousedown);
    };
  }, [/*activeChoice, choiceLabel*/]);

  const showChoices = () => {
    setChoicesDisplayed(prev => !prev);
    setActiveChoice(valueChoice);

    if (valueChoice) {
      syncScroll(choices.findIndex(c => choiceValue(c) === choiceValue(valueChoice)));
    }
  };

  const syncScroll = index => {
    if (!choicesRef.current) {
      return;
    }

    const element = choicesRef.current.getElementsByClassName("choice")[index];

    if (element.offsetTop + element.offsetHeight > choicesRef.current.scrollTop + choicesRef.current.offsetHeight) {
      choicesRef.current.scrollTo(0, element.offsetTop + element.offsetHeight - choicesRef.current.offsetHeight + 10);
    } else if (element.offsetTop < choicesRef.current.scrollTop) {
      choicesRef.current.scrollTo(0, index === 0 ? 0 : element.offsetTop - 10);
    }
  }

  const onKeyDown = e => {
    if (e.key === "ArrowDown") {
      e.preventDefault();

      if (!choicesDisplayed) {
        showChoices();

        return;
      }

      let newIndex;

      if (activeChoice === null) {
        newIndex = 0;
      } else {
        const index = choices.findIndex(c => choiceValue(c) === choiceValue(activeChoice));

        newIndex = index + 1 === choices.length ? 0 : index + 1;
      }

      activateChoice(choices[newIndex]);

      syncScroll(newIndex);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();

      if (!choicesDisplayed) {
        showChoices();

        return;
      }

      let newIndex;

      if (activeChoice === null) {
        newIndex = choices.length - 1;
      } else {
        const index = choices.findIndex(c => choiceValue(c) === choiceValue(activeChoice));

        newIndex = index - 1 < 0 ? choices.length - 1 : index - 1;
      }

      activateChoice(choices[newIndex]);

      syncScroll(newIndex);
    } else if (choicesDisplayed && e.key === "Enter") {
      if (activeChoice) {
        e.preventDefault();

        chooseChoice(activeChoice);
      }
    } else if (e.key === "Escape") {
      if (choicesDisplayed) {
        setChoicesDisplayed(false);
      }
    } else if (e.key === "Tab") {
      if (choiceDisplay) {
        setChoicesDisplayed(false);
      }
    } else if (/^[a-zA-Z]$/.test(e.key)) {
      const letter = e.key;

      let activeChoiceIndex = activeChoice ? choices.findIndex(c => choiceValue(c) === choiceValue(activeChoice)) + 1 : 0;
      let newIndex = -1;

      for (let i = activeChoiceIndex; i < choices.length; i++) {
        if (choiceLabel(choices[i]).toLowerCase().startsWith(letter.toLowerCase())) {
          newIndex = i;

          break;
        }
      }

      if (newIndex === -1) {
        for (let i = 0; i < activeChoiceIndex; i++) {
          if (choiceLabel(choices[i]).toLowerCase().startsWith(letter.toLowerCase())) {
            newIndex = i;

            break;
          }
        }
      }

      if (newIndex >= 0) {
        activateChoice(choices[newIndex]);

        if (!choicesDisplayed) {
          setChoicesDisplayed(true);

          setTimeout(() => syncScroll(newIndex), 0);
        } else {
          syncScroll(newIndex);
        }
      }
    }
  };

  const activateChoice = choice => {
    if (choice !== activeChoice) {
      setActiveChoice(choice);
    }
  };

  const chooseChoice = choice => {
    const newValue = choice ? choiceValue(choice) : value;

    if (newValue !== value) {
      onChange(newValue);
    }

    setActiveChoice(choice);
    setChoicesDisplayed(false);
  };

  let lastGroup;

  return <div
    className={clsx(styles.dropdown, choicesDisplayed ? styles.visible : null, disabled ? styles.disabled : null)}
    ref={dropdownRef}
  >
    <Form.Control
      type="text"
      className={styles.inputPlaceholder}
      isInvalid={isInvalid}
      value={""}
      onChange={() => {
      }}
      onKeyDown={onKeyDown}
      onMouseDown={showChoices}
      id={id}
      disabled={disabled}
      readOnly
    />

    <div className={styles.currentValue}>{valueChoice ? choiceDisplay(valueChoice, true) : null}</div>

    <span className={clsx("material-icons", styles.dropdownIcon)}>arrow_drop_down</span>

    <div className={styles.choices} ref={choicesRef}>
      {choices.map(choice => {
        let groupComponent = <></>;

        if (choiceGroup && choice[choiceGroup] && choice[choiceGroup] !== lastGroup) {
          groupComponent = <div className={styles.choiceGroup}>{choice[choiceGroup]}</div>;

          lastGroup = choice[choiceGroup];
        }

        return <Fragment key={choiceValue(choice)}>
          {groupComponent}

          <div
            className={clsx(styles.choice, activeChoice === choice ? styles.active : null, "choice")}
            onClick={() => chooseChoice(choice)}
            onMouseEnter={() => activateChoice(choice)}
          >
            {choiceDisplay(choice)}
          </div>
        </Fragment>;
      })}
    </div>
  </div>;
};

const DefaultChoiceDisplay = choice => <div>{choice.label}</div>;
